import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class ChapterFacade {
  private readonly store: Store = inject(Store);
}
